import compose from 'recompose/compose';
import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';

import withToggle from 'app/common/containers/withToggle';
import mapPropsCreate from 'app/common/containers/mapPropsCreate';
import { createSelectPeriods } from 'app/components/Tariff/Periods';

import MonthDailyPeriodsSubscribe from './MonthDailyPeriodsSubscribe';


export default compose(
  withToggle(),

  mapPropsCreate(() => {
    const selectPeriods = createSelectPeriods();
    return props => ({
      ...props,
      periods: selectPeriods(props),
    });
  }),

  branch(
    ({ isPeriodSubscribed, subId }) => (!isPeriodSubscribed && subId),
    // если еще не оформлена подписка ни на один пакет
    renderComponent(MonthDailyPeriodsSubscribe)
  )
);
